import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { redirectIfAuthenticatedGuard } from '@lfg-guards/auth-redirect/auth-redirect.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'sign-in'},
  {
    path: 'sign-in',
    loadChildren: () => import('./core/authentication/sign-in/sign-in.module').then(m => m.SignInModule),
    canActivate: [redirectIfAuthenticatedGuard],
  },
  { path: 'terms', loadChildren: () => import('./features/views/private/terms/terms.module').then(m => m.TermsModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
